module.exports = __webpack_public_path__ + "media/blog_elevation_console_card.cc43d476.mp4";